import { type ReactElement, FormEvent, useState, useEffect } from "react"
import userImage from '../../../assests/Icons/user.svg';
import passwordImage from '../../../assests/Icons/lock.svg';
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/app/store";
import { loginUser, loginUserWithToken } from "../hooks/userAuth";
import { useNavigate } from "react-router-dom";
import { SubmitHandler, useForm } from "react-hook-form";
import Saving from "src/components/Saving";

type LoginFields = {
        EmailId: string;
        Password: string;
}

export default function LoginForm(): ReactElement {
        const { register, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm<LoginFields>();
        const dispatch = useDispatch<AppDispatch>();
        const { authError, authUser } = useSelector((state: RootState) => state.auth);
        const navigate = useNavigate();

        const onSubmit: SubmitHandler<LoginFields> = async (data) => {
                await dispatch(loginUser(data));
        }

        const forgotPassword = (event: React.MouseEvent<HTMLLabelElement>) => {
                event.preventDefault();
                navigate("/ForgotPassword");
        }


        useEffect(() => {
                const token = localStorage.getItem('authToken');
                if (authUser !== null) {
                        if (authUser.UserType === "admin") {
                                navigate('/dealers');
                        }
                        else if (authUser.UserType === "dealer") {
                                navigate('/endUsers', { state: { dealerID: authUser.DealerId } });
                        }
                }
                if (authUser === null && token !== null) {
                        dispatch(loginUserWithToken(token));
                }
                if (authError !== null) {
                        setError("root", {
                                message: authError,
                        })
                }
        }, [authUser, authError])

        return <>
                <div className="w-full p-6 max-md:max-w-lg mx-auto">
                        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                                <div className="mb-8">
                                        <h3 className="text-gray-800 text-3xl font-bold">Sign in</h3>
                                </div>
                                <div className="mt-4">
                                        <label className="text-gray-800 text-[15px] mb-2 block">Email</label>
                                        <div className="relative flex items-center">
                                                <input type="text" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter Email" {...register("EmailId", { required: "Email is required", pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: "Enter a valid Email Address" }, })} />
                                                <img src={userImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" />
                                        </div>
                                        {errors.EmailId && (
                                                <div className="text-red-500">{errors.EmailId.message}</div>
                                        )}
                                </div>

                                <div className="mt-4">
                                        <label className="text-gray-800 text-[15px] mb-2 block">Password</label>
                                        <div className="relative flex items-center">
                                                <input type="password" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter password" {...register("Password", { required: "Password is required", minLength: { value: 8, message: "Password must be atleast 8 characters" } })} />
                                                <img src={passwordImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" />
                                        </div>
                                        {errors.Password && (
                                                <div className="text-red-500">{errors.Password.message}</div>
                                        )}
                                </div>
                                <div className="mt-8">
                                        <button disabled={isSubmitting} type="submit" className="w-full py-3 px-4 text-sm tracking-wide rounded-xs text-white bg-blue-600 hover:bg-blue-700 focus:outline-none">
                                                {isSubmitting ? <Saving title="Signing In" color="white" /> : "Sign In"}
                                        </button>
                                </div>
                                <div className="mb-8 text-center py-3">
                                        <label className="text-blue-300 font-bold cursor-pointer" onClick={forgotPassword}>Forgot Password?</label>
                                </div>
                        </form>
                        {errors.root && (
                                <div className="flex justify-center font-bold text-red-500 pt-4">{errors.root.message}</div>
                        )}
                </div>
        </>
}
